import { StateCartEntry } from '../../carts/CartsState';

export interface CartEntriesDifferences {
  readonly addedEntries: Array<StateCartEntry>;
  readonly removedEntries: Array<StateCartEntry>;
}

export function calculateCartEntriesDifferences(
  previousEntries: ReadonlyArray<StateCartEntry>,
  currentEntries: ReadonlyArray<StateCartEntry>
): CartEntriesDifferences {
  const previousEntriesMap: Map<string, StateCartEntry> = mapCartEntriesById(previousEntries);
  const currentEntriesMap: Map<string, StateCartEntry> = mapCartEntriesById(currentEntries);

  const addedEntries: Array<StateCartEntry> = [];
  const removedEntries: Array<StateCartEntry> = [];

  currentEntriesMap.forEach((currentEntry, id) => {
    const previousEntry: StateCartEntry | undefined = previousEntriesMap.get(id);
    if (previousEntry) {
      const quantityDifference = currentEntry.quantity - previousEntry.quantity;
      if (quantityDifference > 0) {
        const updatedEntry: StateCartEntry = { ...currentEntry, quantity: quantityDifference };
        addedEntries.push(updatedEntry);
      } else if (quantityDifference < 0) {
        const updatedEntry: StateCartEntry = {
          ...previousEntry,
          quantity: Math.abs(quantityDifference)
        };
        removedEntries.push(updatedEntry);
      }
      previousEntriesMap.delete(id);
    } else {
      addedEntries.push(currentEntry);
    }
  });

  previousEntriesMap.forEach((removedEntry) => removedEntries.push(removedEntry));

  return { addedEntries, removedEntries };
}

function mapCartEntriesById(entries: ReadonlyArray<StateCartEntry>): Map<string, StateCartEntry> {
  return new Map(entries.map((entry) => [entry.id, entry]));
}
